export const SMS_CHAT_TABLE = "smsChats"
export const SMS_CHAT_TABLE_SCHEMA =
  "id, companyId, userId, accountId, archived, enabled, lastMessageDate, syncId"
